import { render, staticRenderFns } from "./UpdateClassRoom.vue?vue&type=template&id=deab76a4"
import script from "./UpdateClassRoom.vue?vue&type=script&lang=js"
export * from "./UpdateClassRoom.vue?vue&type=script&lang=js"
import style0 from "./UpdateClassRoom.vue?vue&type=style&index=0&id=deab76a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports